// How long a finished roll stays on screen: the rolled dice and the damage popup, for players and the DM.
export const ROLL_DISPLAY_MS = 3000;
